import React, { useEffect, useRef, useState } from "react";
import classes from "./Shortz.module.css";
import AuthModal from "../Components/Modals/AuthModal";
import NavbarMobile from "../Components/NavbarMobile";
import Navbar from "../Components/Navbar";
import BottomNavbar from "../Components/BottomNavbar";
import BackgroundShortz from "../Components/BackgroundShortz";
import { useGetShortzQuery } from "../Slices/httpSlice";
import { motion } from "framer-motion";
import ShortzVideoPlayer from "../Components/ShortzVideoPlayer";
import SearchModal from "../Components/SearchModal";
import WatchlistModal from "../Components/WatchlistModal";
import UserRatingsModal from "../Components/UserRatingsModal";
import ProfileModal from "../Components/ProfileModal";
import Drawer from "../Components/Drawer";

const Shortz = () => {
  const navbarRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);
  const [shortz, setShortz] = useState<any[]>([]);

  const [fetchTimes, setFetchTimes] = useState<number>(0);
  const [fetchData, setFetchData] = useState<boolean>(true);
  const [length, setLength] = useState<number>(10);

  const lastItemRef = useRef<HTMLDivElement>(null);

  const { data, isFetching, refetch, isError } = useGetShortzQuery(null);

  function getDataSimultaneously() {
    if (fetchData) {
      refetch();
    }
  }

  useEffect(() => {
    if (data?.result) {
      setShortz((prevValue) =>
        prevValue ? [...prevValue, data.result] : [data.result]
      );
    }
  }, [data]);

  useEffect(() => {
    setFetchTimes(shortz.length);
  }, [shortz]);

  useEffect(() => {
    if (isFetching) {
      return;
    } else if (fetchTimes <= length) {
      getDataSimultaneously();
    } else {
      setFetchData(false);
    }
  }, [fetchTimes, isFetching, length]);

  useEffect(() => {
    if (navbarRef.current) {
      setHeight(navbarRef.current.offsetHeight);
    }
  }, [navbarRef]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          console.log("fetch the data again as it is under viewport...");
          setFetchData(true);
          setLength(shortz.length + 10);
        }
      },
      { threshold: 0.5 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [length, fetchData, lastItemRef]);

  console.log({ fetchData, fetchTimes, length }, "data...");

  console.log(shortz, "shortz...");

  const rootRef=useRef(null);

  return (
    <>
      <BackgroundShortz>
        <AuthModal />
        <NavbarMobile applyPadding={true} />
        <Navbar activeLink={5} ref={navbarRef} applyPadding={true} />

        <div className={classes.shortz_container} ref={rootRef}>
          {shortz.length <= 1 && (
            <div className={classes.shortz_player}>
              <motion.div
                className={classes.shortz_loading}
                initial={{
                  background:
                    "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
                }}
                animate={{
                  background: [
                    "linear-gradient(45deg, hsl(228deg 14% 7%) 0%, hsl(228deg 11% 8%) 20%, hsl(228deg 8% 9%) 29%, hsl(228deg 5% 11%) 36%, hsl(228deg 3% 12%) 43%, hsl(0deg 0% 14%) 50%, hsl(228deg 3% 12%) 57%, hsl(228deg 5% 11%) 64%, hsl(228deg 8% 9%) 71%, hsl(228deg 11% 8%) 80%, hsl(228deg 14% 7%) 100%)",
                    "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
                    "linear-gradient(45deg,hsl(228deg 14% 7%) 0%,hsl(228deg 11% 8%) 20%,hsl(228deg 8% 9%) 29%,hsl(228deg 5% 11%) 36%,hsl(228deg 3% 12%) 43%,hsl(0deg 0% 14%) 50%,hsl(0deg 0% 14%) 57%,hsl(0deg 0% 14%) 64%,hsl(0deg 0% 14%) 71%,hsl(0deg 0% 14%) 80%,hsl(0deg 0% 14%) 100%)",
                  ],
                }}
                transition={{
                  duration: 2,
                  repeatType: "mirror",
                  repeat: Infinity,
                  ease: "linear",
                }}
              ></motion.div>
            </div>
          )}
          {shortz.map((item, idx) => {
            let lastFivthItem = idx === shortz.length - 5;
            let lastItem = idx === shortz.length - 1;
            if (lastItem) {
              return (
                <div
                  className={classes.shortz_player}
                  key={idx}
                  ref={lastItemRef}
                >
                  <ShortzVideoPlayer item={item} idx={idx} rootRef={rootRef} />
                </div>
              );
            }
            if (lastFivthItem) {
              return (
                <div
                  className={classes.shortz_player}
                  key={idx}
                  ref={lastItemRef}
                >
                  <ShortzVideoPlayer item={item} idx={idx} rootRef={rootRef}/>
                </div>
              );
            } else {
              return (
                <div className={classes.shortz_player} key={idx}>
                  <ShortzVideoPlayer item={item} idx={idx} rootRef={rootRef} />
                </div>
              );
            }
          })}
        </div>
        <BottomNavbar activeLink={4} />
        <SearchModal />
      </BackgroundShortz>
      <WatchlistModal />
      <UserRatingsModal />
      <ProfileModal />
      <Drawer />

    </>
  );
};

export default Shortz;
